module.exports = __webpack_public_path__ + "./fonts/FontAwesome5_Pro_Light.ttf";